import * as z from "zod";
import { PlaidErrorSchema } from "./PlaidError";

export const firestoreDocPlaidItemSchema = z.object({
  plaid_item_id: z.string(),
  access_token: z.string(),
  created_timestamp_secs: z.number(),
  transaction_cursor: z.string().nullable(),
  investment_transaction_last_sync_timestamp_secs: z.number().optional(), // intended as a cursor for plaid transaction syncing
  last_successful_sync_timestamps: z
    .object({
      transaction_sync_timestamp_secs: z.number().optional().nullable(),
      account_sync_timestamp_secs: z.number().optional().nullable(),
    })
    .optional()
    .nullable(),
  sync_errors: z
    .object({
      transaction_sync_error: PlaidErrorSchema.optional().nullable(),
      account_sync_error: PlaidErrorSchema.optional().nullable(),
    })
    .optional()
    .nullable(),
});

export type FirestoreDocPlaidItem = z.infer<typeof firestoreDocPlaidItemSchema>;

export const PlaidItemSafeSchema = firestoreDocPlaidItemSchema.omit({
  access_token: true,
});

export type PlaidItemSafe = z.infer<typeof PlaidItemSafeSchema>;
